module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "withContent": true,
      "maxWidth": 'default'
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('main', {
    class: {
      loading: _vm.loading
    },
    attrs: {
      "id": "template-form"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("plano.saveAsModal.saveAsLabel")))]), _vm._v(" "), _c('form', [_c('label', {
    attrs: {
      "required": "",
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t("template.form.name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTemplate.name),
      expression: "newTemplate.name"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.error.name
    },
    attrs: {
      "id": "name",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.newTemplate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTemplate.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": "",
      "for": "ref"
    }
  }, [_vm._v(_vm._s(_vm.$t("template.form.ref")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTemplate.ref),
      expression: "newTemplate.ref"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.error.ref
    },
    attrs: {
      "id": "ref"
    },
    domProps: {
      "value": (_vm.newTemplate.ref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTemplate.ref = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "txtCenter"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveNewTemplate($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ad738c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/modal/ModalSaveAsTemplate.vue
// module id = 3209
// module chunks = 0